import { configConstants } from "../../constants/config";
export const setTitle = (title) => (dispatch) => {
  dispatch({
    type: configConstants.CHANGE_TITLE,
    payload: title,
  });
}
